import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import HotRankingSection from '@/pages/home/components/HotRankingSection';
import LatestSection from '@/pages/home/components/LatestSection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import TagSection from '@/pages/home/components/TagSection';
import SubmitSection from '@/pages/home/components/SubmitSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main>
        <HeroSection />
        <HotRankingSection />
        <LatestSection />
        <FeaturedSection />
        <TagSection />
        <SubmitSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}